import { render, staticRenderFns } from "./benefitsSchools.vue?vue&type=template&id=11d25e57&"
import script from "./benefitsSchools.vue?vue&type=script&lang=js&"
export * from "./benefitsSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports